import { useCallback, useMemo } from 'react';
import { useTracker } from 'framework-listing-lib/internal/providers/TrackerProvider';
import useUIMode from 'framework-listing-lib/internal/hooks/useUIMode';
import listingLibPerformanceTracking from 'framework-listing-lib/internal/utils/performanceTracking';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
export default function useCrmObjectTypeTracking() {
  const objectType = useObjectTypeId();
  const uiModeProps = useUIMode();
  const {
    applicationId,
    track,
    onTrackEvent
  } = useTracker();
  const trackCrmTableInteraction = useCallback(eventProps => {
    if (onTrackEvent) {
      onTrackEvent(eventProps.action, eventProps);
    }
    track === null || track === void 0 || track('Crm Table', 'Crm Table Interaction', Object.assign({
      applicationId,
      objectType,
      uiMode: uiModeProps.currentUIMode
    }, eventProps));
  }, [applicationId, objectType, onTrackEvent, track, uiModeProps.currentUIMode]);
  const trackFilterEditorInteraction = useCallback(eventProps => {
    if (onTrackEvent) {
      onTrackEvent(eventProps.action, eventProps);
    }
    track === null || track === void 0 || track('Filter Editor', 'Filter Editor Interaction', Object.assign({
      applicationId,
      objectType
    }, eventProps));
  }, [applicationId, objectType, onTrackEvent, track]);
  const trackPerformanceInteraction = useCallback(() => {
    listingLibPerformanceTracking.trackLibPerformance({
      applicationId,
      objectTypeId: objectType,
      track
    });
  }, [applicationId, objectType, track]);
  const value = useMemo(() => ({
    trackCrmTableInteraction,
    trackFilterEditorInteraction,
    trackPerformanceInteraction
  }), [trackCrmTableInteraction, trackFilterEditorInteraction, trackPerformanceInteraction]);
  return value;
}